import Api from "../../axios"

export const postRejectAttendanceRequest= async({id, reason})=>{
    return await Api.post('reject_attendance',{
        application_id: id,
        reason
    })
}